import React from 'react';

const ActivityCard = ({ title, iconSrc, bgColor, tilt }) => {
  // Calculate border rotation with more pronounced effect
  const borderRotation = tilt.includes('2') ? 
    (tilt.includes('-r') ? '-rotate-6' : 'rotate-6') : 
    tilt;
  
  return (
    <div className="relative group">
      <div className={`rounded-xl h-full p-4 sm:p-2 flex flex-col items-center space-y-2 sm:space-y-3 relative overflow-hidden transform ${tilt} transition-all duration-300 hover:scale-105 z-0`}>
        <img src={iconSrc} alt="" className="w-12 h-12 sm:w-24 sm:h-24 mb-2 sm:mb-3" />
        <p className="text-primary text-center font-bold text-base sm:text-xl px-2 sm:px-3">{title}</p>
      </div>
      <div className={`absolute inset-0 rounded-xl border-2 border-primary ${borderRotation} transition-all duration-300 group-hover:border-primary group-hover:scale-105 z-10`} />
    </div>
  );
};

const ActivityGrid = () => {
  const activities = [
    {
      title: "Watch a movie in a Cinema",
      iconSrc: "LGA-CommunityParticipation-Cinema-Icon.svg",
      tilt: "rotate-2"
    },
    {
      title: "Join a Social Group/Club",
      iconSrc: "LGA-CommunityParticipation-SocialGroup-Activities-REVISED.svg",
      tilt: "-rotate-2"
    },
    {
      title: "Embrace your Inner Artist",
      iconSrc: "LGA-CommunityParticipation-Art-Icon.svg",
      tilt: "rotate-2"
    },
    {
      title: "Visit your Local Library",
      iconSrc: "LGA-CommunityParticipation-Library-Icon.svg",
      tilt: "-rotate-2"
    },
    {
      title: "Go to a Concert",
      iconSrc: "LGA-CommunityParticipation-Concert-Icon.svg",
      tilt: "rotate-2"
    },
    {
      title: "Fry a Feast at Cooking Class",
      iconSrc: "LGA-CommunityParticipation-Cooking-Icon.svg",
      tilt: "-rotate-2"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-16 p-4 sm:p-6 max-w-5xl mx-auto py-8 sm:py-16">
      {activities.map((activity, index) => (
        <ActivityCard
          key={index}
          title={activity.title}
          iconSrc={"/Icons/"+activity.iconSrc}
          bgColor={activity.bgColor}
          tilt={activity.tilt}
        />
      ))}
    </div>
  );
};

export default ActivityGrid;